

export const getBaseURL = () => {

  let currentDomain;

  if (typeof window !== "undefined") {

    // Retrieve the current domain name
     currentDomain = window.location.hostname;
    // Create a domain-to-University map
   
  }else {
    currentDomain = "localhost"
  }

  // if (typeof window !== "undefined") {

    // const currentDomain = window.location.hostname;  
      const domainToURLMap = {
        'localhost': process.env.NEXT_PUBLIC_CONECAO_URL_LOCAL_candidatures,

      ['futuriss2.futurissvision.com']: process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_FUTURISSVISION_CANDIDATURES,
      ['www.futuriss2.futurissvision.com']: process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_FUTURISSVISION_CANDIDATURES,


      ['istaangola.com']: process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_ISTA,
      ['www.istaangola.com']: process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_ISTA,

      ['siguc.ispozls.com']: process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_ISPOZANGOLS_CANDIDATURES,
      ['www.siguc.ispozls.com']: process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_ISPOZANGOLS_CANDIDATURES,

      ['testesangola.futurissvision.com']: process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_FUTURISSTESTS_CANDIDATURES,
      ['www.testesangola.futurissvision.com']: process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_FUTURISSTESTS_CANDIDATURES,

      ['ucansoft.net']: process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_UCAN,
      ['www.ucansoft.net']: process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_UCAN,

      ['futuriss.unikinrdc.com']: process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_UNIKINRDC_CANDIDATURES,
      ['www.futuriss.unikinrdc.com']: process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_UNIKINRDC_CANDIDATURES,

      ['futuriss.lecartesienrdc.com']: process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_LECARTESIEN,
      ['www.futuriss.lecartesienrdc.com']: process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_LECARTESIEN,

      ['futuriss.petitslutinsapp.com']: process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_PETTISLUTINS,
      ['www.futuriss.petitslutinsapp.com']: process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_LECARTESIEN,

      ['futuriss.ideroapp.com']: process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_IDERO_CANDIDATURES,
      ['www.futuriss.ideroapp.com']: process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_IDERO_CANDIDATURES,

      ['cum.futurissvision.com']: process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_CUM_CANDIDATURES,
      ['www.cum.futurissvision.com']: process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_CUM_CANDIDATURES,

      ['futuriss.ispozangosede.com']: process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_ISPOZANGOSEDE_CANDIDATURES,
      ['www.futuriss.ispozangosede.com']: process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_ISPOZANGOSEDE_CANDIDATURES,

      ['futuriss.sieraschools.com']: process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_SIERASCHOOL_CANDIDATURES,
      ['www.futuriss.sieraschools.com']: process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_SIERASCHOOL_CANDIDATURES,

      ['ease.futurissvision.com']: process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_ESAE_CANDIDATURES

    };
    
    const baseURL = domainToURLMap[currentDomain] || process.env.NEXT_PUBLIC_CONECAO_URL_LOCAL_candidatures;  
    if (!baseURL) {
      return "http://localhost:3310/api"; // Fallback URL for error cases
    }

    
    return baseURL || process.env.NEXT_PUBLIC_CONECAO_URL_LOCAL_candidatures;
  };

// }
  